import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShare = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.27266 2.18164H1.9697C0.881864 2.18164 0 3.06351 0 4.15134V12.0301C0 13.118 0.881866 13.9998 1.9697 13.9998H9.84849C10.9363 13.9998 11.8182 13.118 11.8182 12.0301V5.72737H11.0303V12.0301C11.0303 12.6828 10.5012 13.212 9.84849 13.212H1.9697C1.317 13.212 0.787879 12.6828 0.787879 12.0301V4.15134C0.787879 3.49864 1.317 2.96952 1.9697 2.96952H8.27266V2.18164Z",
		fill: "#4F31FF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5.60277 7.78343C5.43354 7.95266 5.43354 8.22703 5.60277 8.39626C5.77199 8.56548 6.04637 8.56548 6.21559 8.39626L5.60277 7.78343ZM13.4334 0.99893C13.4334 0.759606 13.2394 0.565596 13.0001 0.565596L9.10009 0.565596C8.86077 0.565596 8.66676 0.759606 8.66676 0.998929C8.66676 1.23825 8.86077 1.43226 9.10009 1.43226L12.5668 1.43226L12.5668 4.89893C12.5668 5.13826 12.7608 5.33227 13.0001 5.33227C13.2394 5.33227 13.4334 5.13826 13.4334 4.89893L13.4334 0.99893ZM6.21559 8.39626L13.3065 1.30534L12.6937 0.692516L5.60277 7.78343L6.21559 8.39626Z",
		fill: "#4F31FF"
	})]
});
export default SvgShare;
